import * as PIXI from "pixi.js";

/**
 * Creates a PIXI texture with evenly divided color segments (no gradient blending).
 *
 * @param {string[]} colors - Array of CSS color strings (e.g. ["#FCB900", "#7BDCB5", "#FF6900"])
 * @param {"horizontal" | "vertical"} direction - Split direction
 * @returns {PIXI.Texture}
 */
export function createStripedTexture(colors: string[], direction = "horizontal") {
  if (!colors || colors.length === 0) return PIXI.Texture.WHITE;

  const canvas = document.createElement("canvas");
  canvas.width = direction === "horizontal" ? 256 : 1;
  canvas.height = direction === "vertical" ? 256 : 1;

  const ctx = canvas.getContext("2d");
  if (!ctx) return PIXI.Texture.WHITE;

  const segmentSize =
    direction === "horizontal" ? canvas.width / colors.length : canvas.height / colors.length;

  ctx.globalAlpha = 0.7; // 👈 set transparency globally

  colors.forEach((color, i) => {
    ctx.fillStyle = color;

    if (direction === "horizontal") {
      ctx.fillRect(i * segmentSize, 0, segmentSize, canvas.height);
    } else {
      ctx.fillRect(0, i * segmentSize, canvas.width, segmentSize);
    }
  });

  ctx.globalAlpha = 1; // reset to default (important for re-use)

  return PIXI.Texture.from(canvas);
}
